// src/components/Navbar/index.js
import Navbar from './Navbar';
export default Navbar;
